import actions from './actions';
import models from './models';
import createReducer from './reducer';

import { createSelector, ORM } from 'redux-orm';

const orm = new ORM();
orm.register(...models);

const reducer = createReducer(orm);

const createOrmSelector = (...args) => createSelector(orm, ...args);

export { actions as ormActions, createOrmSelector };

export default reducer;



// WEBPACK FOOTER //
// ./src/orm/index.js